An optional hirer-provided free-text job reference.
